import { Link } from "react-router-dom";
import { Send, Instagram, Youtube } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from "@/constants/support";

const Footer = () => (
  <footer className="relative border-t border-black/10 bg-white py-14" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row">
        <div className="max-w-md">
          <div className="flex items-center gap-2.5">
            <BrandLogo className="text-lg" />
          </div>
          <p className="mt-5 text-xs leading-relaxed text-slate-500">
            Trading in commodities and currencies involves substantial risk of loss and is not
            suitable for every investor. Past performance of any call, bias or VIP trade does not
            guarantee future results. 50 CR CLUB provides education and analysis — not investment
            advice. Never trade with capital you cannot afford to lose.
          </p>
        </div>
        <div className="flex flex-wrap gap-x-12 gap-y-8 sm:gap-16">
          <div>
            <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#0a0a0a]">Contact</p>
            <ul className="mt-4 space-y-2 text-sm text-slate-600">
              <li><a data-testid="footer-support-phone" href={`tel:${SUPPORT_PHONE_TEL}`} className="transition-colors hover:text-[#0a0a0a]">{SUPPORT_PHONE_DISPLAY}</a></li>
              <li><a data-testid="footer-telegram-link" href="https://t.me/team50CrClub_bot" target="_blank" rel="noreferrer" className="transition-colors hover:text-[#0a0a0a]">Telegram Desk</a></li>
              <li><a data-testid="footer-email-link" href="mailto:desk@50crclub.in" className="transition-colors hover:text-[#0a0a0a]">desk@50crclub.in</a></li>
            </ul>
          </div>
          <div>
            <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#0a0a0a]">Legal</p>
            <ul className="mt-4 space-y-2 text-sm text-slate-600">
              <li><Link data-testid="footer-legal-terms" to="/terms" className="transition-colors hover:text-[#0a0a0a]">Terms of Service</Link></li>
              <li><Link data-testid="footer-legal-refund" to="/refund-policy" className="transition-colors hover:text-[#0a0a0a]">Refund Policy</Link></li>
              <li><Link data-testid="footer-legal-disclaimer" to="/risk-disclaimer" className="transition-colors hover:text-[#0a0a0a]">Risk Disclaimer</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#0a0a0a]">Socials</p>
            <div className="mt-4 flex gap-3">
              {[
                { icon: Send, id: "send" },
                { icon: Instagram, id: "instagram" },
                { icon: Youtube, id: "youtube" },
              ].map(({ icon: Icon, id }) => (
                <a
                  key={id}
                  data-testid={`footer-social-${id}`}
                  href="#"
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-black/10 text-slate-500 transition-all hover:border-black/40 hover:text-[#0a0a0a]"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-black/10 pt-6 sm:flex-row sm:items-center">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-400">
          © 2026 50 CR CLUB · All rights reserved
        </p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-400">
          Trade with a plan. Manage your risk.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
